import React from 'react'

import Loading from '../../../components/layout/Loading'
import SelectInput from '../../../components/form/SelectInput'
import { useI18N } from '../../../../libraries/i18n/hook'
import { useVideoTypes } from '../../../../hocs/content/useVideos'

type Props = {
  onChange: (values: { videoTypes: string[] }) => void,
  values?: string[]
}
const TypeSelectBox: React.FC<Props> = ({ values, onChange }) => {
  const { t } = useI18N()
  const { data, isLoading } = useVideoTypes()

  const handleChange = (ids: string[]) => {
    onChange({ videoTypes: ids })
  }

  if(isLoading) return <Loading />
  const options = data?.map(({ name, id }) => ({ label: name, value: id.toString() }))
  if(!options) return null
  return (
    <SelectInput
      isDisabled={options?.length === 0}
      value={options?.filter((type) => values?.includes(type.value.toString()))}
      name='types'
      label={t('content.videoTypes')}
      onChange={handleChange}
      options={options}
      autoMinWidth
    />
  )
}

export default TypeSelectBox
